import { useEffect, useRef } from "react"
import { ClFarmStore } from "@/domains/cl-farm/cl-farm-store"
import useEcharts from "@/hooks/useEcharts"
import { observer } from "mobx-react-lite"

export const ClFarmsBreakdownChart = observer(({ clFarm }: { clFarm: ClFarmStore | null | undefined }) => {
  const chartRef = useRef<HTMLDivElement>(null)
  const echarts = useEcharts()

  const { token0Percentage, token1Percentage } = clFarm?.tokenPercentages ?? {
    token0Percentage: 0,
    token1Percentage: 0,
  }

  useEffect(() => {
    if (!chartRef.current) return

    const chart = echarts.init(chartRef.current, "equalizer")

    const option = {
      tooltip: {
        trigger: "item",
      },
      legend: {
        show: false,
        top: "0%",
        left: "center",
      },
      series: [
        {
          name: `${clFarm?.displayName} breakdown`,
          type: "pie",
          radius: ["64%", "96%"],
          animation: false,
          avoidLabelOverlap: true,
          color: ["#9CA8FF", "#5A7CFF"],
          padAngle: 2,
          itemStyle: {
            borderRadius: 2,
            borderColor: "#fff",
            borderWidth: 0,
          },
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            label: {
              show: false,
              fontSize: 10,
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: token0Percentage.toFixed(2), name: clFarm?.token0.symbol },
            { value: token1Percentage.toFixed(2), name: clFarm?.token1.symbol },
          ],
        },
      ],
    }

    chart.setOption(option)

    const handleResize = () => {
      chart.resize()
    }
    window.addEventListener("resize", handleResize)

    return () => {
      chart.dispose()
      window.removeEventListener("resize", handleResize)
    }
  }, [echarts, token0Percentage, token1Percentage])

  return <div ref={chartRef} style={{ width: "100%", height: "220px" }} />
})
